"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Header", {
  enumerable: true,
  get: function get() {
    return _Header["default"];
  }
});
Object.defineProperty(exports, "Footer", {
  enumerable: true,
  get: function get() {
    return _Footer["default"];
  }
});

require("./style/index.css");

require("./ext/webcomponents-bundle.js");

require("./ext/custom-elements-es5-adapter.js");

require("regenerator-runtime/runtime");

var _preactCustomElement = _interopRequireDefault(require("preact-custom-element"));

var _Header = _interopRequireDefault(require("./components/Header"));

var _Footer = _interopRequireDefault(require("./components/Footer"));

var _settings = require("./constants/settings");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

(0, _preactCustomElement["default"])(_Footer["default"], 'mtn-footer', _settings.FOOTER_PROPS.map(function (prop) {
  return prop.toLowerCase();
}));
(0, _preactCustomElement["default"])(_Header["default"], 'mtn-header', _settings.HEADER_PROPS.map(function (prop) {
  return prop.toLowerCase();
}));